/** Keep the daily selection current even when Shopify serves cached HTML. */
(() => {
  const widths = [240, 352, 832, 1200, 1600, 1920, 2560, 3840];
  const dayAt = (timestamp) => Math.floor((timestamp + 7200000) / 86400000);

  function refresh() {
    const day = dayAt(Date.now());
    document.querySelectorAll('[data-ms-daily-collection-image]').forEach((card) => {
      const image = card.querySelector('img');
      const poolNode = card.querySelector('[data-ms-daily-image-pool]');
      if (!image || !poolNode || card.dataset.msDailyImageDay === String(day)) return;
      try {
        const pool = JSON.parse(poolNode.textContent);
        if (!pool.length) return;
        const selected = pool[day % pool.length];
        const source = new URL(selected.url, window.location.href);
        if (source.protocol !== 'https:') return;
        image.srcset = widths.map((width) => {
          const url = new URL(source);
          url.searchParams.set('width', String(width));
          return `${url.href} ${width}w`;
        }).join(', ');
        source.searchParams.set('width', '3840');
        image.src = source.href;
        image.alt = selected.alt || '';
        image.width = selected.width;
        image.height = selected.height;
        card.dataset.msDailyImageDay = String(day);
      } catch {
        // Leave the server-rendered collection image in place.
      }
    });
  }

  function scheduleNextDay() {
    const now = Date.now();
    const nextDay = (dayAt(now) + 1) * 86400000 - 7200000;
    window.setTimeout(() => {
      refresh();
      scheduleNextDay();
    }, nextDay - now + 1000);
  }

  refresh();
  scheduleNextDay();
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refresh();
  });
})();
